<div class="margin-top-large">
  <app-component-level-error-message [errorMessage]="errorMessage"></app-component-level-error-message>
  @if (uiState === uiStateEnum.ShowLoading) {
    <app-loading-card-content></app-loading-card-content>
  } @else if (uiState == uiStateEnum.ShowData) {
    <div class="justify-space-between flex-row align-start">
      <div>
        <div class="section-header">Multiple Standard Game Reports</div>
        <div class="ticket-type-header">Date Range:</div>
        {{ dateRanges.StartDate | date: 'MMM d, y HH:mm' }} -
        {{ dateRanges.EndDate | date: 'MMM d, y HH:mm' }}
      </div>
      <div>
        <button mat-raised-button class="margin-left-small" (click)="downloadAsCSV()"
                data-testid="standard-report-generate-pdf-button">Generate CSV
        </button>
      </div>
    </div>
    <div class="full-width">
      <ag-grid-angular
        id="reportsGrid"
        class="ag-theme-quartz"
        [rowData]="reports"
        rowSelection="single"
        [domLayout]="'autoHeight'"
        (gridReady)="multipleStandardGridReady($event)"
        [pagination]="true"
        rowClass="table-row table-row-hover choose-instance-row"
        [paginationPageSize]="10"
        [columnDefs]="standardGameReportDefs">
      </ag-grid-angular>
    </div>
  }
</div>
